import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ColumnSettings } from '../../common/models';

@Component({
    selector: 'text-viewer',
    templateUrl: './text-viewer.component.html',
    styleUrls: ['./text-viewer.component.scss'],
    
})
export class TextViewerComponent implements OnChanges {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;

  public escapedValue: string = '';

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    //this.escapedValue = this.record[this.column.field];
  }
}
